import { Box, Typography } from "@material-ui/core";
import { Option, Options } from "../../../store/types";

const InvestorDetailsPreview: React.FC<{ investorData: Options }> = function (
  props
) {
  const { investorData } = props;
  return (
    <Box
      sx={{
        marginTop: "40px",
        marginRight: "40px",
        bgcolor: "rgba(32, 87, 166, 0.1)",
        padding: "20px",
        boxShadow: "0px 0px 8px 0px rgba(202, 202, 202, 1);",
        borderRadius: "4px",
        minHeight: "100%",
      }}
    >
      <Typography
        style={{
          color: "rgba(0, 124, 197, 1)",
          fontSize: "16px",
          fontFamily: "OpenSans-SemiBold",
          fontWeight: "700",
        }}
      >
        Other Details
      </Typography>
      {investorData.map(({ label, value }, index) => (
        <SchemeData key={label} value={value} label={label} />
      ))}
    </Box>
  );
};

const SchemeData: React.FC<Option> = function (props) {
  const { label, value } = props;
  return (
    <Box
      sx={{
        marginTop: "20px",
      }}
    >
      <Typography
        style={{
          color: "rgba(41, 49, 57, 0.7)",
          fontSize: "14px",
          fontWeight: "400",
        }}
      >
        {label}
      </Typography>
      <Typography
        style={{
          fontSize: "14px",
          fontWeight: "600",
          wordBreak: "break-all",
        }}
      >
        {value || "-"}
      </Typography>
    </Box>
  );
};

export default InvestorDetailsPreview;
